import { LOAD_SETTINGS_ACTION_TYPES } from '../actions/loadSettings.actions';

const initialState = {
  dateFilter: [],
  verificationFilter: null,
};

export default function(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case (LOAD_SETTINGS_ACTION_TYPES.CHANGE_LOAD_DATE):
      return {
        ...state,
        dateFilter: payload,
      };

    case (LOAD_SETTINGS_ACTION_TYPES.RESET_LOAD_DATE):
      return {
        ...state,
        dateFilter: initialState.dateFilter,
      };

    case (LOAD_SETTINGS_ACTION_TYPES.CHANGE_LOAD_VERIFICATION):
      return {
        ...state,
        verificationFilter: payload,
      };

    case (LOAD_SETTINGS_ACTION_TYPES.RESET_LOAD_VERIFICATION):
      return {
        ...state,
        verificationFilter: initialState.verificationFilter,
      };

    default:
      return state;
  }
}